import React from "react";
import { Button, ButtonGroup } from "react-bootstrap";

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
  const handlePrevious = () => {
    if (currentPage > 1) {
      onPageChange(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      onPageChange(currentPage + 1);
    }
  };

  return (
    <div className="d-flex justify-content-end mt-3">
      <ButtonGroup>
        <Button
          variant="outline-secondary"
          onClick={handlePrevious}
          disabled={currentPage === 1}
        >
          Previous
        </Button>
        <span className="d-flex align-items-center mx-2">
          Page {currentPage} of {totalPages}
        </span>
        <Button
          variant="outline-secondary"
          onClick={handleNext}
          disabled={currentPage === totalPages}
        >
          Next
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default Pagination;
